import { FC } from 'react'
import { IInput } from './Input'
import Label from './Label'
import Truncate from '../Truncate'

const Switch: FC<
  Omit<IInput, 'value' | 'handle'> & {
    value: boolean
    handleToggle: () => unknown
    isNoLabelArea?: boolean
    size?: 'tiny' | 'small' | 'medium' | 'large'
    isTrunicate?: boolean
    variant?: 'primary' | 'pale'
  }
> = ({
  value,
  handleToggle,
  label,
  isNoLabelArea = false,
  size = 'medium',
  className,
  isTrunicate = false,
  error,
  description,
  variant = 'primary',
}) => {
  return (
    <div
      className={`
        flex flex-col
        ${
          {
            tiny: '',
            small: '',
            medium: 'mt-1 gap-1',
            large: 'mt-2 gap-2',
          }?.[size]
        } 
        ${className || ''}        
      `}
    >
      {!!!isNoLabelArea && <Label size={size}> </Label>}
      <div
        className={`
        flex items-center
        ${
          {
            tiny: '',
            small: '',
            medium: 'mt-1 gap-1 h-[46px]',
            large: 'mt-2 gap-2 h-[46px]',
          }?.[size]
        } 
        ${className || ''}
      `}
      >
        <button
          type='button'
          className={[
            'bg-gray-200 relative inline-flex flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2',
            value
              ? {
                  primary: 'bg-primary',
                  pale: 'bg-slate-400',
                }?.[variant]
              : 'bg-gray-200',
            {
              tiny: 'h-4 w-7',
              small: 'h-5 w-9',
              medium: 'h-6 w-11',
              large: 'h-7 w-14',
            }?.[size],
          ].join(' ')}
          role='switch'
          aria-checked={value ? 'true' : 'false'}
          aria-labelledby={String(label)}
          onClick={() => handleToggle()}
        >
          <span
            aria-hidden='true'
            className={`
              translate-x-0 pointer-events-none inline-block transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out 
              ${
                {
                  tiny: `h-3 w-3 ${value ? 'translate-x-3' : 'translate-x-0'}`,
                  small: `h-4 w-4 ${value ? 'translate-x-4' : 'translate-x-0'}`,
                  medium: `h-5 w-5 ${value ? 'translate-x-5' : 'translate-x-0'}`,
                  large: `h-6 w-6 ${value ? 'translate-x-7' : 'translate-x-0'}`,
                }?.[size]
              } 
            `}
          />
        </button>
        <span
          className={`
            ml-3 ${value ? 'text-gray-900' : 'text-gray-400'}
            ${
              {
                tiny: 'text-xs font-medium min-h-[18px]',
                small: 'font-semibold min-h-[24px]',
                medium: 'text-md font-semibold min-h-[24px]',
                large: 'text-lg font-semibold min-h-[24px]',
              }?.[size]
            }
          `}
          id={String(label)}
        >
          {isTrunicate ? <Truncate>{label}</Truncate> : label}
        </span>
      </div>
      {!!error && <div className='text-pink-600 text-sm mt-1'>{error}</div>}
      {!!description && <div className='text-slate-600 text-sm mt-1'>{description}</div>}
    </div>
  )
}

export default Switch
